var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloseGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9487 5.63668C17.3384 5.24529 17.9702 5.24529 18.3598 5.63668C18.7495 6.02806 18.7495 6.66261 18.3598 7.05399L13.4085 12.0271L18.335 16.9752C18.7246 17.3666 18.7246 18.0011 18.335 18.3925C17.9453 18.7839 17.3135 18.7839 16.9239 18.3925L11.9974 13.4444L7.07099 18.3925C6.68132 18.7839 6.04955 18.7839 5.65988 18.3925C5.27022 18.0011 5.27022 17.3666 5.65988 16.9752L10.5863 12.0271L5.63502 7.05399C5.24536 6.66261 5.24536 6.02806 5.63502 5.63668C6.02469 5.24529 6.65646 5.24529 7.04613 5.63668L11.9974 10.6098L16.9487 5.63668Z",
    fill: "#6D757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseGray);
export default __webpack_public_path__ + "static/media/icon-close-gray.af777b35793e665ffa4f0645ac7381cd.svg";
export { ForwardRef as ReactComponent };